/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/Actions/DeleteAction/Content",
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let questionIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'question',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="critical"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../RemoveModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../RemoveModal/Content'))}
 paddingTop={dtSpaceXs}
 paddingLeft={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 paddingRight={dtSpaceXs}
 data="question"
 disabled={questionIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Remove"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}